import { UserType } from '../../enums/user/userType.enum';
import { NavItem } from '../../interface/nav_items/nav_items.interface';

export const NAV_ITEMS_SUPERADMIN: NavItem[] = [
  {
    name: 'Gestión Agencias',
    url: '/admin/agencies',
    iconComponent: { name: 'cil-grid' },
    userType: UserType.SUPERADMIN,
    children: [
      {
        name: 'Ver Agencias',
        url: '/admin/agencies',
        icon: 'nav-icon-bullet',
      },
    ],
  },
  {
    name: 'Gestión Suscripciones',
    url: '/admin/subscriptions',
    iconComponent: { name: 'cil-shield-alt' },
    userType: UserType.SUPERADMIN,
    children: [
      {
        name: 'Ver Suscripciones',
        url: '/admin/subscriptions',
        icon: 'nav-icon-bullet',
      },
    ],
  },
];
